// Filterbare overzichten (actueelBlock, projectenBlock): keuzelijsten (.js-filter select), zoekveld (.js-zoekveld)
// en paginering (.js-pagination) in de browser. Per sectie .js-haspagination; kaarten zijn .js-item met data-values
// (komma-gescheiden: type, locatie, status). Keuzelijsten en zoekveld werken samen.
const PAGE_SIZE = 6;
const MAX_BUTTONS = 5;

class Overview {
    private items: HTMLElement[];
    private selects: HTMLSelectElement[];
    private search: HTMLInputElement | null;
    private pagination: HTMLElement | null;
    private visible: HTMLElement[];
    private page = 1;

    constructor(section: HTMLElement) {
        this.items = Array.from(section.querySelectorAll<HTMLElement>('.js-item'));
        this.selects = Array.from(section.querySelectorAll<HTMLSelectElement>('.js-filter select'));
        this.search = section.querySelector<HTMLInputElement>('.js-zoekveld');
        this.pagination = section.querySelector<HTMLElement>('.js-pagination');
        this.visible = this.items;

        for (const select of this.selects) {
            select.addEventListener('change', () => this.apply());
        }
        if (this.search) {
            this.search.addEventListener('input', () => this.apply());
        }
        if (this.pagination) {
            this.pagination.addEventListener('click', (event) => {
                const button = (event.target as HTMLElement).closest('.pagination-btn') as HTMLButtonElement | null;
                if (button && !button.disabled) { this.show(Number(button.getAttribute('data-page'))); }
            });
        }

        this.show(1);
    }

    /** Filtert op alle gekozen waarden én alle zoekwoorden, en begint weer op pagina 1. */
    private apply() {
        const values = this.selects.map(s => s.value.toLowerCase()).filter(v => v);
        const keywords = (this.search ? this.search.value : '').toLowerCase().trim().split(/\s+/).filter(k => k);

        this.visible = this.items.filter((item) => {
            const itemValues = (item.getAttribute('data-values') || '').toLowerCase().split(',').map(v => v.trim());
            const text = (item.textContent || '').toLowerCase();
            return values.every(v => itemValues.indexOf(v) >= 0) && keywords.every(k => text.indexOf(k) >= 0);
        });

        this.show(1);
    }

    private show(page: number) {
        this.page = page;
        const start = (page - 1) * PAGE_SIZE;
        const current = this.visible.slice(start, start + PAGE_SIZE);
        for (const item of this.items) {
            item.style.display = current.indexOf(item) >= 0 ? '' : 'none';
        }
        this.renderButtons();
    }

    /** Vorige, maximaal 5 paginanummers rond de huidige pagina, volgende. Geen knoppen bij één pagina. */
    private renderButtons() {
        if (!this.pagination) { return; }
        const total = Math.ceil(this.visible.length / PAGE_SIZE);
        if (total <= 1) {
            this.pagination.innerHTML = '';
            return;
        }

        let start = Math.max(1, this.page - Math.floor(MAX_BUTTONS / 2));
        const end = Math.min(total, start + MAX_BUTTONS - 1);
        start = Math.max(1, end - MAX_BUTTONS + 1);

        const nav = (page: number, icon: string, disabled: boolean) =>
            `<button class="pagination-btn pagination-btn--nav" data-page="${page}" ${disabled ? 'disabled' : ''}><span class="material-symbols-outlined">${icon}</span></button>`;

        let html = nav(this.page - 1, 'arrow_left_alt', this.page === 1);
        for (let i = start; i <= end; i++) {
            html += `<button class="pagination-btn${i === this.page ? ' active' : ''}" data-page="${i}"><span>${i}</span></button>`;
        }
        html += nav(this.page + 1, 'arrow_right_alt', this.page === total);
        this.pagination.innerHTML = html;
    }
}

for (const section of Array.from(document.querySelectorAll<HTMLElement>('.js-haspagination'))) {
    new Overview(section);
}

export {};
